import { useEffect, useRef, useState } from 'react'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../../../constants/common'
import { useOutboundUuid } from '../../../../../../hooks'
import { useEmailThreadProfileLoaders } from '../../../../../Email'
import {
  getRequestEmailMessages,
  getRequestThreadProfile,
  toggleRequestThreadRead,
} from '../../../RequestProfileTabEmails.api'

export function useRequestProfileTabEmailsThreadModalLoaders({
  isReadEnabled = true,
  mailUuid,
  requestId,
  onSuccessRead,
}) {
  const outboundUuid = useOutboundUuid()

  async function getMessages({ options, params } = EMPTY_OBJECT) {
    const { email_thread_uuid: requestThreadUuid, ...restParams } =
      params ?? EMPTY_OBJECT

    return getRequestEmailMessages({
      options,
      outboundUuid,
      params: {
        ...restParams,
        request_thread_uuid: requestThreadUuid,
      },
      requestId,
    }).then(response => ({
      ...response,
      data: {
        ...response.data,
        items: (response.data?.items ?? EMPTY_LIST).map(item => ({
          ...item,
          email_thread_uuid: mailUuid,
        })),
      },
    }))
  }

  async function getProfileData({ options, params, uuid } = EMPTY_OBJECT) {
    return getRequestThreadProfile({
      options,
      outboundUuid,
      params,
      requestId,
      uuid,
    })
  }

  async function readApi({ read, uuid }) {
    return toggleRequestThreadRead({ outboundUuid, read, requestId, uuid })
  }

  const profileLoaders = useEmailThreadProfileLoaders({
    getMessages,
    getProfileData,
    getSummaryData: null,
    isReadEnabled,
    mailUuid,
    readApi,
    withWidgets: false,
    onSuccessRead,
  })

  const { handleReloadProfile, isInitiated, loadEmailMessages } = profileLoaders

  useEffect(() => {
    if (isInitiated) {
      loadEmailMessages()
    }
  }, [isInitiated])

  const [isReloadingThread, setIsReloadingThread] = useState(false)

  const previousMailUuidRef = useRef(mailUuid)

  function reloadForNewThread() {
    if (previousMailUuidRef.current !== mailUuid) {
      previousMailUuidRef.current = mailUuid

      if (isInitiated) {
        setIsReloadingThread(true)
        handleReloadProfile().finally(() => {
          setIsReloadingThread(false)
        })
      }
    }
  }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- reloads thread data when the mail changes
    reloadForNewThread()
  }, [handleReloadProfile, isInitiated, mailUuid])

  return { ...profileLoaders, isReloadingThread }
}
